import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaSearch, FaRegHeart, FaBars, FaTimes } from 'react-icons/fa'
import { IoBagCheckOutline } from 'react-icons/io5'
import { GoChevronDown } from 'react-icons/go'

import './index.css'

const HeaderPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  const closeMenu = () => setIsMenuOpen(false)

  return (
    <nav className="nav-header">
       {/* Mobile Dropdown Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/products" onClick={closeMenu}>Shop</Link></li>
          <li><Link to="/skills" onClick={closeMenu}>Skills</Link></li>
          <li><Link to="/stories" onClick={closeMenu}>Stories</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
        </ul>
      </div>

      <div className="nav-content">
        {/* Logo Section */}
        <div className="nav-logo-section">
          <img
            className="website-logo"
            src="/Gemini_Generated_Image_4ytrkx4ytrkx4ytr.png"
            alt="website logo"
          />
          <h1 className="logo-text">LOGO</h1>
        </div>

        {/* Desktop Menu */}
        <ul className="nav-menu">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/products" className="nav-link">Shop</Link>
          <Link to="/skills" className="nav-link">Skills</Link>
          <Link to="/stories" className="nav-link">Stories</Link>
         <Link to="/about" className="nav-link">About</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </ul>

        {/* Icons + Hamburger */}
        <div className="icons-container">
          <FaSearch  />
          <FaRegHeart  />
          <IoBagCheckOutline  />
          <p className="lang">Eng</p>
          <GoChevronDown />

          {/* Hamburger Icon for Mobile */}
          <button className="hamburger" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

     
    </nav>
  )
}

export default HeaderPage


